import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import { WorkdayReportService } from "../../workday-report.service";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-category-extra-hours",
  templateUrl: "./categories-extra-hours.component.html",
  styleUrls: ["./categories-extra-hours.component.scss"],
})
export class CategoriesExtraHoursComponent implements OnInit {
  public contentHeader: IContentHeader;
  public categories: { id: number; name: string }[];
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public currentCategory: { id: number; name: string };
  public new_category: string = "";
  public showModalError: boolean = false;

  constructor(
    public _workdayService: WorkdayReportService,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    private router: Router,
  ) {
    this.contentHeader = {
      headerTitle: italian.data.MENU.CATEGORIES_EXTRA_HOURS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.CATEGORIES_EXTRA_HOURS,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    await this.loadCategories();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadCategories() {
    this.categories = await this._workdayService.getCategoriesList();
  }

  categoryList() {
    let items: { id: number; name: string }[] = this.categories || [];

    const keywords: string = this.searchKeyword.trim().toLowerCase();
    if (keywords.length > 0) {
      items = items.filter((item: { id: number; name: string }) => item.name.toLowerCase().includes(keywords));
    }

    return items;
  }

  async addCategory() {
    if (!this._authenticationService.hasCapability("workday_category_create")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.new_category) {
      this.new_category = this.new_category.trim();
    }

    if (!this.new_category || this.new_category.length < 1) {
      this.showModalError = true;
      return false;
    }

    const data: { name: string } = {
      name: this.new_category,
    };
    this._utilService.showLoading();
    await this._workdayService
      .createCategory(data)
      .then(async () => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_CATEGORY_EXTRA_HOURS" });
        await this.loadCategories();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_CREATE_CATEGORY_EXTRA_HOURS" });
      });
  }

  async editCategory() {
    if (!this._authenticationService.hasCapability("workday_category_edit")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.currentCategory.name) {
      this.currentCategory.name = this.currentCategory.name.trim();
    }

    if (!this.currentCategory.name || this.currentCategory.name.length < 1) {
      this.showModalError = true;
      return false;
    }

    const data: { name: string } = {
      name: this.currentCategory.name,
    };
    this._utilService.showLoading();
    await this._workdayService
      .updateCategory(this.currentCategory.id, data)
      .then(() => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_CATEGORY_EXTRA_HOURS" });
        this.loadCategories();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPDATE_CATEGORY_EXTRA_HOURS" });
      });
  }

  async deleteCategory(currentCategory) {
    if (!this._authenticationService.hasCapability("workday_category_delete")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentCategory.name;

    await this._utilService
      .showSWALDeleteConfirmation({
        title: "CONFIRM_DELETE_TITLE",
        text: deleteText,
        icon: "warning",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._workdayService.deleteCategory(currentCategory.id);
          await this._utilService.showPopupItemDeleted().then(async () => {
            await this.loadCategories();
          });
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_CATEGORY_EXTRA_HOURS_REMOVE" }));
  }

  public modalOpen(modalBasic, currentCategoryId: number) {
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.new_category = "";
    this.currentCategory = JSON.parse(JSON.stringify(currentCategoryId));
    this.showModalError = false;
  }
}
